export default function Divider() {
  return <div className="bg-border my-1 h-[1px] min-h-[1px] w-full" />;
}
